/**
 * @description 触发弹框事件
 * @author wangfupeng
 */

export default function (eventData = {}) {
    const refedId = eventData.refedId
    if (!refedId) {
        console.error('弹框组件 id 未找到', refedId)
        return
    }

    // 找到弹框组件
    const elem = document.getElementById(refedId)
    if (elem == null) {
        console.error('id 找不到弹框组件 elem', refedId)
        return
    }

    // 显示弹框组件
    elem.style.display = 'block'
}
